import { IconButton, Paper, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import styled from 'common/styled-components';

export const Fields = styled.div`
    max-width: 1499px;
    display: grid;
    margin: 0 auto;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-column-gap: 10px;
`;

export const NarrativeCheckbox = styled.div`
    display: flex;
    flex-direction: row-reverse;
`;

export const NarrativeToolbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    max-width: 1499px;
    margin: 0 auto;
`;

export const BottomFields = styled.div`
    display: block;
    margin: 15px auto;
    max-width: 1499px;
    width: 100%;
`;

export const FieldContainer = styled.div<{minHeight?: number}>`
    ${props => props.minHeight ? `min-height: ${props.minHeight}px;` : ``}
`

export const NarrativeFieldContainer = styled.div<{color: string, isHighlighted?: boolean}>`
    padding: 8px;
    background-color: ${props => props.isHighlighted ? 'transparent' : props.theme.white.main};
    border-radius: 3px;
    overflow: hidden;
    .DraftEditor-root {
        ${props => props.color ? `color: ${props.color};` : ``}
    }
    label {
        ${props => props.color ? `color: ${props.color} !important;` : ``}
    }
`
export const ApprovalContainer = styled.div`
    max-width: 1499px;
    display: grid;
    margin-top: 6px;
    grid-template-columns: 80px 100px 200px auto;
    grid-column-gap: 10px;
    color: ${props => props.theme.black.dark};
    opacity:0.38;
`;

export const ApprovalHeader = styled.div`
    grid-column: 1;
    grid-row: 1/10;
`;

export const MatterContainer = styled.div<{draft: boolean}>`
    display: grid;
    grid-template-columns: ${props => props.draft ? 'calc(100% - 48px) 48px' : '100%'};
`;

export const BillingRulesIcon = styled(IconButton)`
    width: 30px;
    height: 30px;
    margin: 14px 0 0 10px !important;
`;

export const BillingRulesContainer = styled(Paper)`
    position: fixed;
    right: 0;
    top: 0;
    min-width: 200px;
    max-width: 235px;
    min-height: 200px;
    padding: 8px;
    background: ${props => props.theme.white.dark} !important;
    z-index: 1200;
`;

export const BillingTitleContainer = styled.div`
    display: flex;
`;

export const BillingTitle = styled(Typography)`
    font-size: 1rem !important;
    text-align: center;
    flex-grow: 1;
`;

export const BiilingCloseIcon = styled(Close)`
    &:hover {
        background-color: ${props => props.theme.grey.dark};
        border-radius: 50%;
        cursor: pointer;
    }
`;

export const BillingBodyContainer = styled.div`
    overflow: auto;
    max-height: calc(100vh - 500px);
`;

export const BillingSubtitleContainer = styled(Typography)`
    margin-bottom: 4px !important;
`;

export const BillingSubtitle = styled(Typography)`
    display: inline !important;
`;

export const BillingBannedContainer = styled(Typography)`
    display: grid !important;
    grid-template-columns: 50% 50%;
    margin: 2px !important;
    grid-column-gap: 2px;
`;

export const BillingBannedItem = styled.div`
    border: .5px solid ${props => props.theme.black.light};
    border-right: 1px solid ${props => props.theme.black.light};
    border-bottom: 1px solid ${props => props.theme.black.light};
    margin: 2px;
    padding: 0 8px;
`;